import { useEffect } from "react";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import { useRecipe } from "./../hooks/recipe";
import { useMyIngredientRequested } from "./../hooks/myIngredientRequested";
import { useResetRecipe } from "modules/Recipes/hooks/recipe";
import RecipeSuggestions from "modules/Recipes/components/RecipeSuggestions/index";
import { useCustomNavigate } from 'core/hooks/useCustomNavigate';

const RecipesPage = () => {
  useScrollToTop()
  const navigate = useCustomNavigate()
  const { ingredients, options, keyword, resetRecipes, isIgnoreIds } = useRecipe()
  const { addToMyIngredientsRequest } = useMyIngredientRequested()
  const onResetRecipeSuggestion = useResetRecipe()
  useEffect(() => {
    if (ingredients.length) {
      addToMyIngredientsRequest(ingredients)
    }
  }, [ingredients])

  const handleGoBack = () => {
    onResetRecipeSuggestion()
    navigate(-1)
  }

  return (
    <AppLayout>
      <PageHeader
        title={_t('ingredient.recipe_title')}
        sticky
        handleGoBack={handleGoBack}
      />
      <RecipeSuggestions
        ingredients={ingredients}
        options={options}
        keyword={keyword}
        isIgnoreIds={isIgnoreIds}
      />
      <BottomNavigation
        onNavigateChange={resetRecipes}
        activeIndex={2}
      />
    </AppLayout>
  );
};

export default RecipesPage;
